/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_CopiedInputs */

const en_link_copied = /** @type {(inputs: Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Copied!`)
};

const id_link_copied = /** @type {(inputs: Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan Disalin!`)
};

/** @type {(inputs: Link_CopiedInputs) => LocalizedString} */
const es_link_copied = en_link_copied;

/** @type {(inputs: Link_CopiedInputs) => LocalizedString} */
const fr_link_copied = en_link_copied;

/** @type {(inputs: Link_CopiedInputs) => LocalizedString} */
const de_link_copied = en_link_copied;

/** @type {(inputs: Link_CopiedInputs) => LocalizedString} */
const ja_link_copied = en_link_copied;

/** @type {(inputs: Link_CopiedInputs) => LocalizedString} */
const zh_link_copied = en_link_copied;

/** @type {(inputs: Link_CopiedInputs) => LocalizedString} */
const ar_link_copied = en_link_copied;

/** @type {(inputs: Link_CopiedInputs) => LocalizedString} */
const it_link_copied = en_link_copied;

/** @type {(inputs: Link_CopiedInputs) => LocalizedString} */
const ru_link_copied = en_link_copied;

/** @type {(inputs: Link_CopiedInputs) => LocalizedString} */
const pt_link_copied = en_link_copied;

/** @type {(inputs: Link_CopiedInputs) => LocalizedString} */
const ko_link_copied = en_link_copied;

/**
* | output |
* | --- |
* | "Link Copied!" |
*
* @param {Link_CopiedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_copied = /** @type {((inputs?: Link_CopiedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_CopiedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_copied(inputs)
	if (locale === "es") return es_link_copied(inputs)
	if (locale === "fr") return fr_link_copied(inputs)
	if (locale === "de") return de_link_copied(inputs)
	if (locale === "ja") return ja_link_copied(inputs)
	if (locale === "zh") return zh_link_copied(inputs)
	if (locale === "ar") return ar_link_copied(inputs)
	if (locale === "id") return id_link_copied(inputs)
	if (locale === "it") return it_link_copied(inputs)
	if (locale === "ru") return ru_link_copied(inputs)
	if (locale === "pt") return pt_link_copied(inputs)
	return ko_link_copied(inputs)
});